<template lang="pug">
    el-container.has-centered-content.verify-email-container
        .panel-container
            .logo
                progressive-img(:src="require('@/assets/CObyVA.svg')")
            .panel-form
                .card.z-depth-2(v-loading="loading")
                    .verification-content
                        template(v-if="success")
                            .icon.success
                                i.far.el-icon-fa-check-circle
                            h3 {{ $t('Email verified') }}
                            p {{ $t('Your email address has been verified successfully.') }}
                            el-button.mt-4(
                                type="primary"
                                size="large"
                                @click="goToLogin"
                            ) {{ $t('Go to login') }}

                        template(v-else-if="alreadyVerified")
                            .icon.info
                                i.far.el-icon-fa-check-circle
                            h3 {{ $t('Already verified') }}
                            p {{ $t('Your email address has already been verified.') }}
                            el-button.mt-4(
                                type="primary"
                                size="large"
                                @click="goToLogin"
                            ) {{ $t('Go to login') }}

                        template(v-else-if="error")
                            .icon.error
                                i.far.el-icon-fa-times-circle
                            h3 {{ $t('Verification failed') }}
                            p {{ errorMessage }}
                            el-button.mt-4(
                                type="primary"
                                size="large"
                                @click="goToLogin"
                            ) {{ $t('Go to login') }}

                        template(v-else)
                            .icon.pending
                                i.far.el-icon-fa-envelope
                            h3 {{ $t('Verifying email') }}
                            p {{ $t('Please wait while we verify your email address...') }}
</template>

<i18n>
{
    "de": {
        "Email verified": "E-Mail bestätigt",
        "Your email address has been verified successfully.": "Ihre E-Mail-Adresse wurde erfolgreich bestätigt.",
        "Already verified": "Bereits bestätigt",
        "Your email address has already been verified.": "Ihre E-Mail-Adresse wurde bereits bestätigt.",
        "Verification failed": "Bestätigung fehlgeschlagen",
        "The verification link is invalid or has expired.": "Der Bestätigungslink ist ungültig oder abgelaufen.",
        "Go to login": "Zur Anmeldung",
        "Verifying email": "E-Mail wird bestätigt",
        "Please wait while we verify your email address...": "Bitte warten Sie, während Ihre E-Mail-Adresse bestätigt wird..."
    }
}
</i18n>

<script>
import axios from 'axios'

export default {
    name: 'VerifyEmail',
    data() {
        return {
            loading: true,
            success: false,
            alreadyVerified: false,
            error: false,
            errorMessage: ''
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        },
        hash() {
            return this.$route.params.hash
        },
        expires() {
            return this.$route.params.expires
        },
        signature() {
            return this.$route.params.signature
        }
    },
    methods: {
        goToLogin() {
            this.$router.push('/')
        },
        async verifyEmail() {
            try {
                const url = `${process.env.VUE_APP_API_ENDPOINT}email/user/verify`
                // Parameters must be in alphabetical order for signature validation
                const params = new URLSearchParams({
                    expires: this.expires,
                    hash: this.hash,
                    id: this.id,
                    signature: this.signature
                })

                const response = await axios.post(`${url}?${params.toString()}`)

                if (response.data.success) {
                    this.success = true
                } else if (response.data.message === 'Email is already verified.') {
                    this.alreadyVerified = true
                } else {
                    this.error = true
                    this.errorMessage = response.data.message || this.$t('The verification link is invalid or has expired.')
                }
            } catch (err) {
                this.error = true
                const message = (err.response && err.response.data && err.response.data.message) || ''
                if (message === 'Email is already verified.') {
                    this.alreadyVerified = true
                    this.error = false
                } else {
                    this.errorMessage = message || this.$t('The verification link is invalid or has expired.')
                }
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        this.verifyEmail()
    }
}
</script>

<style lang="sass">
.public .verify-email-container
    align-self: flex-start
    width: 100%

    .card
        background: #f9f9f9
</style>

<style lang="sass" scoped>
.verification-content
    text-align: center
    padding: 20px 0

    .icon
        font-size: 3rem
        margin-bottom: 1rem

        &.success
            color: #67c23a

        &.info
            color: #409eff

        &.error
            color: #f56c6c

        &.pending
            color: #909399

    h3
        margin-bottom: 0.5rem
        color: #303133
        font-weight: normal

    p
        color: #606266
        margin-bottom: 0

.mt-4
    margin-top: 1.5rem
</style>
